import { combineReducers } from 'redux'
import config from './config'
import room from './room'
import ui from './ui'
import docs, { syncUi } from './docs'
import { reducers } from '@bt-react/store'
import chat from './chat'
import notifications from './notifications'
import slides from './slides'
import tracks from './tracks'
import dialIn from './dialIn'
import sessionStatus from './sessionStatus'
import QandAReducer from './questions'
import syncSeatingOrder from './docs/syncSeatingOrder'
import { playInReducer } from '../slices/playIn'
import { communicationsReducer } from '../slices/communications'
import { messagingReducer } from '../slices/messaging'
import { votesReducer } from '../slices/votes'
import { eventStreamReducer } from '../slices/eventStream'
import { layoutsReducer } from '../slices/layouts'
import { userSettingsReducer } from '../slices/userSettings'
import { qualityWarningReducer } from '../slices/qualityWarning'
import qualityCheckReducer from './qualityCheck'


export default combineReducers({
  client: () => 'talks-present',
  channel: reducers.channel,
  chat,
  communications: communicationsReducer,
  config,
  dialIn,
  docs,
  messaging: messagingReducer,
  notifications,
  playIn: playInReducer,
  questions: QandAReducer,
  room,
  sessionStatus,
  slides,
  syncSeatingOrder,
  syncUi,
  tracks,
  ui,
  user: reducers.user,
  userSettings: userSettingsReducer,
  webcast: reducers.webcast,
  resources: reducers.resources,
  votes: votesReducer,
  eventStream: eventStreamReducer,
  layouts: layoutsReducer,
  qualityWarning: qualityWarningReducer,
  qualityCheck: qualityCheckReducer
})
